require('../modules/es7.object.get-own-property-descriptors');
require('../modules/es7.object.values');
require('../modules/es7.object.entries');
module.exports = require('../modules/$.core').Object;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/es7/object.js
// module id = 880
// module chunks = 1